import React from 'react'
import { BrowserRouter, Route, Routes } from "react-router-dom"
import Home from "./Pages/Home/index"
import TermsAndConditions from "./Pages/TermsAndConditions/index"
import Privacypolicy from "./Pages/privacypolicy/index"
import Requestdeleteaccount from "./Pages/requestdeleteaccount/index"
import RefundAndCancellation from "./Pages/RefundAndCancellation/index"
import DeliveryPolicy from "./Pages/DeliveryPolicy/index"
import About from "./Pages/About/index"
import Contact from "./Pages/Contact/index"
import FAQ from "./Pages/FAQ/index"
import BlogPage from "./Pages/Blog/index"
import BlogPost from "./Pages/BlogPost/index"
import AuthorPage from "./Pages/AuthorPage/index"
import LocationsPage from "./Pages/Locations/index"
import BulkOrder from "./Pages/BulkOrder/index"
import NotFound from "./Pages/NotFound/index"
import ScrollToHash from './Components/ScrollToHash'
import { ApiProvider } from './context/ApiContext'

const App = () => {
  return (
    <ApiProvider>
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/faqs' element={<FAQ />} />
          <Route path='/blog' element={<BlogPage />} />
          <Route path='/blog/:postId' element={<BlogPost />} />
          <Route path='/author/:authorId' element={<AuthorPage />} />
          <Route path='/locations' element={<LocationsPage />} />
          <Route path='/bulk-order' element={<BulkOrder />} />
          <Route path='/termsandconditions' element={<TermsAndConditions />} />
          <Route path='/privacypolicy' element={<Privacypolicy />} />
          <Route path='/requestdeleteaccount' element={<Requestdeleteaccount />} />
          <Route path='/RefundAndCancellation' element={<RefundAndCancellation />} />
          <Route path='/DeliveryPolicy' element={<DeliveryPolicy />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ApiProvider>
  )
}

export default App